import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition; //戻る・進むのときには元々いた場所に戻る
		} else {
			return { x: 0, y: 0 }; //そうでないときはトップへ
		}
	},
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
		},
		// ビジネスプラットフォーム領域
		{
			path: '/business_platform',
			name: 'business_platform',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/BusinessPlatform.vue'),
		},
		// エンベデッド領域
		{
			path: '/embedded',
			name: 'embedded',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/Embedded.vue'),
		},
		// ロボット領域
		{
			path: '/robot',
			name: 'robot',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/Robot.vue'),
		},
		// DX・AIソリューション領域
		{
			path: '/dxai_solution',
			name: 'dxai_solution',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/DxAi.vue'),
		},
		// 事業・プロジェクト紹介
		{
			path: '/business_and_technology',
			name: 'business_and_technology',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/BusinessAndTechnology.vue'),
		},
		{
			path: '/growth',
			name: 'growth_as_an_engineer',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/GrowthAsAnEngineer.vue'),
		},
		{
			path: '/discussion_young',
			name: 'discussion_young',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/DiscussionYoung.vue'),
		},
		{
			path: '/discussion_mgr',
			name: 'discussion_mgr',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/DiscussionMgr.vue'),
		},
		{
			path: '/people_tadahiro',
			name: 'people-tadahiro',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/PeopleTadahiro.vue'),
		},
		{
			path: '/people_satoshi',
			name: 'people-satoshi',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/PeopleSatoshi.vue'),
		},
		{
			path: '/people_seiji',
			name: 'people-seiji',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/PeopleSeiji.vue'),
		},
		{
			path: '/referral',
			name: 'employee_referral_system',
			meta: {
				title: '株式会社豆蔵: 採用情報サイト 社員紹介特設ページ',
			},
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/EmployeeReferralSystem.vue'),
		},
	],
});
